import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchMyBlogProfile() {
  return function withContext(context) {
    const url = `${API_URL}blog/my/profile`;
    return _fetch(url, { withAuth: true }, { method: 'GET' })(context);
  };
}
